import {
    faChartLine,
    faCog,
    faExclamationTriangle,
    faLifeRing,
    faPencil,
    faPlusCircle,
    faRobot,
    faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import {
    ACTION_TO_ADD_POST,
    ADD_FEED_POST,
    COUNSELLING_IS_ARCHIVED,
    FORUM_ADD_CONTEST,
    FORUM_ADD_QUESTION,
    FORUM_POST_ADMINCLUB_MENU,
    FORUM_REPORTED_POSTS,
    FORUM_TOPIC_DELETE,
    FORUM_TOPIC_EDIT, FORUM_TOPIC_SEO_WITH_AI,
    SEO_DESCRIPTION_FORUM_topic,
    SEO_TITLE_FORUM,
    TO_action_YOU_HAVE_TO_BE_loggedIn,
    TO_BE_LOGGED_IN,
} from 'mk/autogenerated/translations/TopicPage.baa280b1f831648a572f0cb7a96128ae'
import { linebreaksbr } from 'mk/bazaar/common/filters';
import { hasAds, isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { adminclub_forum_topic_url } from 'mk/urls/functions';
import { analyticsStoreEvent } from 'mk2/actions';
import { adminclubSeoForumUrl } from 'mk2/apps/adminclub/urls';
import LeftMenu from 'mk2/apps/blogs/components/LeftMenu';
import { contestsHomeUrl } from 'mk2/apps/contests/urls';
import { counsellingsHomeUrl, counsellingsPostDetailUrl, counsellingsTopicUrl } from 'mk2/apps/counsellings/urls';
import { DateRange1, KeywordFilterType } from 'mk2/apps/dash/containers/SeoPerformance/FilterForm';
import { dashSeoPerformaceUrl } from 'mk2/apps/dash/urls';
import { addCounsellingQuestion } from 'mk2/apps/forum/actions';
import {
    CONTESTS_TOPIC_ID,
    COUNSELLING_CATEGORY_ID,
    OTHER_CATEGORY_SLUG,
    TESTINGS_TOPIC_ID,
    UNCATEGORIZED_TOPIC_SLUG,
} from 'mk2/apps/forum/constants';
import Topic from 'mk2/apps/forum/containers/Topic/Topic';
import {
    forumDeleteTopic,
    topicFetchTrigger,
    topicRead,
    topicSetAsFavoriteTrigger,
    topicSubscribeTrigger,
    topicUnsubscribeTrigger,
} from 'mk2/apps/forum/containers/Topic/Topic.actions';
import { TOPIC_MENU_MORE } from 'mk2/apps/forum/containers/Topic/Topic.constants';
import reducer, { TopicState } from 'mk2/apps/forum/containers/Topic/Topic.reducers';
import saga from 'mk2/apps/forum/containers/Topic/Topic.sagas';
import {
    getTopicLastVisitedCount,
    getTopicPostsState,
    getTopicState,
} from 'mk2/apps/forum/containers/Topic/Topic.selectors';
import { topicUrl } from 'mk2/apps/forum/helpers';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ComplaintsStatisticsPerPost,
    CounsellingEntity,
    CounsellingSchema,
    PostEntity,
    PostSchema,
    TopicEntity,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { getForumComplaintsStatisticsForTopic } from 'mk2/apps/forum/selectors';
import { breadcrumbsForum, topicOG } from 'mk2/apps/forum/structuredData';
import {
    forumContestNewUrl,
    forumPostDetailUrl,
    forumPostNewInCategoryUrl,
    forumPostNewInTopicUrl,
    forumReportedUrl,
    forumTopicEditUrl,
    forumTopicUrl,
    forumUrl,
} from 'mk2/apps/forum/urls';
import { GroupFeedPageState } from 'mk2/apps/groups/containers/GroupFeed/GroupFeed.reducers';
import { BrandDaysPosts } from 'mk2/apps/home/components/BrandDaysPosts';
import { loginUrl } from 'mk2/apps/users/urls';
import { MenuItem } from 'mk2/components/menu/MenuItem';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Interpolate } from 'mk2/components/Interpolate';
import { Count } from 'mk2/components/NotificationsBadge';
import { AppName } from 'mk2/containers/Application/Application';
import { Menu } from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { getAllPlaintext } from 'mk2/helpers/article_ast/utils';
import { cacheLast, memoizeOne } from 'mk2/helpers/cache';
import { showWarningToastAction } from 'mk2/helpers/toasts';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import Page, { AnchorLeaderboardProps, BrandingProps, HalfpageProps, InterstitialProps, RightContentSide } from 'mk2/pages/Page';
import {
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    AppState,
} from 'mk2/reducers';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { MenuSelection, UserEntity } from 'mk2/schemas';
import { findDenormalizedEntityBySlug, getDenormalizedEntities, getDenormalizedEntity } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps, StaticContext } from 'react-router';
import styles from './TopicPage.mscss';

const fasCogLg: FontAwesomeIconProps = {icon: faCog, size: 'lg'};
const fasPlusCircleLg: FontAwesomeIconProps = {icon: faPlusCircle, size: 'lg'};

// aby sme vedeli rozlisit medzi poradnami a forum uz pocas LoadingState.INIT a LoadingState.LOADING
// a zobrazovali tak spravne UI
export enum TopicViewType {
    Forum,
    AskAnExpert,
}

export interface OwnProps {}

export interface StateProps {
    after: number;
    viewType: TopicViewType;
    hashtags: string[];
    topic: TopicEntity;
    posts: PostEntity[];
    hasNext: number;
    hasPrevious: number;
    isSubscribed: boolean;
    isFavorite: boolean;
    isMobile: boolean;
    requestUser: UserEntity;
    lastVisitedCount: Count;
    loadingState: LoadingState;
    errorMessage: string;
    brandDaysCampaign: BrandDaysCampaignEntity;
    brandDaysCampaignGreetingText: string;
    counselling: CounsellingEntity;
    counsellingPostsCount: number;
    baseUrl: string;
    permissions: string[];
    complaintsStatistics: ComplaintsStatisticsPerPost;
    subscribers: number;
    activeBrandDaysCampaign: BrandDaysCampaignEntity;
    activeBrandDaysPosts: PostEntity[];
    query: string;
}

export interface DispatchProps {
    onLoad(slug: string, hashtags?: string[], query?: string, after?: number);

    onSubscribe(slug: string, username: string);
    onUnsubscribe(slug: string, username: string);
    onAddToFavorites(topicId: number, userId: number);
    onRemoveFromFavorites(topicId: number, userId: number);

    // From Header - rewrite!
    onTopicDelete(slug: string);
    onStoreEvent(name: string, props: any);
    onTopicToggleMenuMore();
    onTopicRead(topicId: number);
    onShowWarningToast(message: string | React.ReactNode);
    onAddCounsellingQuestion(counselling: CounsellingEntity);

    onRead?(topicId: number);
}

interface StaticContextWithUrl extends StaticContext {
    url: string;
}

export type RouteProps = RouteComponentProps<{
    topicSlug: string;
}, StaticContextWithUrl>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

interface Query {
    after: number;
    query: string;
    hashtags: string[];
}

export default class TopicPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    private onAddPostClicked = cacheLast();
    private onDeleteCache = cacheLast();

    private parseQuery = memoizeOne((qs: string): Query => {
        const qp = parse(qs, { parseNumbers: true }) || {};
        return {
            after: qp.after as number,
            // empty string value is considered correct too and needs to be preserved as such
            query: (qp.q !== undefined) ? qp.q as string : null,
            hashtags: qp.h ? (qp.h as string).split(',') : [],
        };
    });

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const slug = ownProps.match.params.topicSlug;
            const parsedQuery: Query = this.parseQuery(ownProps.location.search);
            const query = parsedQuery.query;
            const after = parsedQuery.after;
            const hashtags = parsedQuery.hashtags;

            const topicState: TopicState = getTopicState(state, slug);
            const topicPostsState = getTopicPostsState(state, slug, hashtags, query);

            const posts = getDenormalizedEntities<PostEntity>(state, PostSchema, topicPostsState.ids);
            const topic = findDenormalizedEntityBySlug<TopicEntity>(state, TopicSchema, slug);

            const lastVisitedCount: Count | null = topic ? getTopicLastVisitedCount(state, topic.id) : null;

            return {
                viewType: TopicViewType.Forum,
                after,
                hashtags,
                topic,
                posts,
                hasNext: topicPostsState.hasNext,
                hasPrevious: topicPostsState.hasPrevious,
                isSubscribed: topicState.isSubscribed,
                isFavorite: topicState.isFavorite,
                lastVisitedCount,
                loadingState: topicPostsState.loadingState,
                errorMessage: topicPostsState.errorMessage,
                brandDaysCampaign: getDenormalizedEntity<BrandDaysCampaignEntity>(state, BrandDaysCampaignSchema, topicState.brandDaysCampaignId),
                brandDaysCampaignGreetingText: topicState.brandDaysCampaignGreetingText,
                counselling: getDenormalizedEntity<CounsellingEntity>(state, CounsellingSchema, topicState.counsellingId),
                counsellingPostsCount: topicState.counsellingPostsCount,
                isMobile: getRequestDeviceMobile(state),
                requestUser: getRequestUser(state),
                baseUrl: getRequestBaseUrl(state),
                permissions: getRequestPermissions(state),
                // Topic can be null when we are loading data
                complaintsStatistics: topic ? getForumComplaintsStatisticsForTopic(state, topic.id) : {},
                subscribers: topicState.subscribers,
                activeBrandDaysCampaign: getDenormalizedEntity<BrandDaysCampaignEntity>(state, BrandDaysCampaignSchema, topicState.activeBrandDaysCampaignId),
                activeBrandDaysPosts: getDenormalizedEntities<PostEntity>(state, PostSchema, topicState.activeBrandDaysPostsIds),
                query,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: topicFetchTrigger,
            onSubscribe: topicSubscribeTrigger,
            onUnsubscribe: topicUnsubscribeTrigger,
            onAddToFavorites: (topicId, userId) => topicSetAsFavoriteTrigger(topicId, userId, true),
            onRemoveFromFavorites: (topicId, userId) => topicSetAsFavoriteTrigger(topicId, userId, false),
            onTopicDelete: forumDeleteTopic,
            onTopicToggleMenuMore: () => menuToggle(TOPIC_MENU_MORE),
            onTopicRead: topicRead,
            onStoreEvent: analyticsStoreEvent,
            onShowWarningToast: showWarningToastAction,
            onAddCounsellingQuestion: addCounsellingQuestion,
        };
    }

    public getMetaTitle(props: Props): string {
        const { topic } = props;
        return topic ? topic.name : SEO_TITLE_FORUM;
    }

    public getMetaDescription(props: Props): string {
        const { topic, brandDaysCampaignGreetingText } = props;

        // FIXME caka na json-markdown aby sme ako description poslali iba plaintext
        if (brandDaysCampaignGreetingText) {
            return brandDaysCampaignGreetingText;
        } else if (topic) {
            return topic.descriptionAST
                ? getAllPlaintext(topic.descriptionAST)
                : interpolate(SEO_DESCRIPTION_FORUM_topic, { topic: topic.name });
        } else {
            return null;
        }
    }

    public getOpenGraphData(props: Props, baseUrl: string, currentUrl: string): {[key: string]: string} {
        const { topic } = props;

        if (topic) {
            return {
                ...super.getOpenGraphData(props, baseUrl, currentUrl),
                ...topicOG(baseUrl, topic),
            };
        }
    }

    public getStructuredData(props: Props): object[] {
        const { topic, baseUrl } = props;

        if (topic) {
            return [breadcrumbsForum(baseUrl, null, topic)];
        }
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        const { topic } = props;
        if (topic) {
            return baseUrl + topicUrl(topic);
        }
    }

    public render(props: Props): false | JSX.Element {
        const { staticContext, match, topic } = props;
        if (topic) {
            // Redirects between /ask-an-expert/, /contests/ and /forum/
            if (topic.id === CONTESTS_TOPIC_ID) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = contestsHomeUrl;
                    return null;
                }
            } else if (topic.category.id === COUNSELLING_CATEGORY_ID && match.path !== counsellingsTopicUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(counsellingsTopicUrl, match.params);
                    return null;
                } else {
                    // history.replace(url(counsellingsTopicUrl, match.params));
                }
            } else if (topic.category.id !== COUNSELLING_CATEGORY_ID && match.path !== forumTopicUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(forumTopicUrl, match.params);
                    return null;
                } else {
                    // history.replace(url(forumTopicUrl, match.params));
                }
            }
        }

        return (
            <Topic key={props.query} {...props} />
        );
    }

    public renderRight(props: Props): JSX.Element {
        const {
            activeBrandDaysCampaign, activeBrandDaysPosts, location, requestUser,
        } = props;

        const showBrandDays = !!activeBrandDaysCampaign && activeBrandDaysPosts.length > 0 && hasAds(requestUser);
        return (
            <>
                {showBrandDays && (
                    <BrandDaysPosts
                        brandDaysCampaign={activeBrandDaysCampaign}
                        brandDaysPosts={activeBrandDaysPosts}
                    />
                )}
                <LeftMenu location={location} />
            </>
        );
    }

    public getRightContentSide(app: AppName, props: Props): RightContentSide {
        return RightContentSide.LeftSide;
    }

    public getDefaultBackPath(props: Props): string {
        const { counselling } = props;
        return counselling ? counsellingsHomeUrl : forumUrl;
    }

    public hasHeaderBackButton(props: Props): boolean {
        const { counselling } = props;
        return !!counselling;
    }

    public hasMobileLogo(props: Props): boolean {
        return true;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        const { topic } = props;
        if (topic && (topic.isCommercial || topic.deletedAt)) {
            return null;
        }

        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        const { isMobile, location, topic } = props;

        // return BarandingProps even if topic is not loaded, except brand days
        if (!topic) {
            return location.pathname.includes('/dni-s') && isMobile
                ? null
                : { zone: 'Forum Category - Branding' };
        }

        if (topic.isCommercial || topic.isBrandDays || topic.deletedAt) {
            return null;
        }

        return {
            zone: 'Forum Category - Branding',
        };
    }

    public getInterstitialProps(props: Props): InterstitialProps | null {
        return { zone: 'Forum Category - Interstitial' };
    }

    public getAnchorLeaderboardProps(props: Props): AnchorLeaderboardProps {
        const { requestUser, isMobile, posts, topic } = props;

        if (!isMobile || requestUser && !hasAds(requestUser)) {
            return null;
        }

        if (!topic || topic.isCommercial || topic.isBrandDays || topic.deletedAt) {
            return null;
        }

        if ((posts?.length || 0) < 10) {
            return null;
        }

        return {
            zone: 'Forum Category - Anchor Ad Leaderboard (Mobile)',
        };
    }

    public getHeaderRight(props: Props): React.ReactElement {
        const {
            requestUser, permissions, topic, complaintsStatistics, location: { pathname },
            onTopicToggleMenuMore, onTopicDelete, counselling, brandDaysCampaign,
            onShowWarningToast, onAddCounsellingQuestion, viewType,
        } = props;

        const isDeleted = topic && topic.deletedAt;
        if (isDeleted) {
            return null;
        }

        const isModerator = topic && isAuthenticatedAs(requestUser, topic.topicModerators?.map((tm) => tm.user) || topic.moderators);
        const isAdmin = permissions.indexOf('forum.can_manage_forum') >= 0;

        const isAskAnExpert = viewType === TopicViewType.AskAnExpert;

        const onAddPostClickedHandler = (event) => {
            if (requestUser && !isAuthenticated(requestUser)) {
                event.preventDefault();
                onShowWarningToast(
                    <Interpolate
                        i18nKey={TO_action_YOU_HAVE_TO_BE_loggedIn}
                        action={ACTION_TO_ADD_POST}
                        loggedIn={(
                            <a
                                data-google-interstitial="false"
                                href={url(loginUrl, {},  {next: location.pathname})}
                            >
                                {TO_BE_LOGGED_IN}
                            </a>
                        )}
                    />,
                );
            } else if (counselling && counselling.isLocked) {
                event.preventDefault();
                onShowWarningToast(linebreaksbr(counselling.lockedMessage));
            }
        };

        let addBtn;
        if (isAskAnExpert) {
            if (counselling) {
                addBtn = (
                    <Btn
                        key="btn"
                        type={BtnType.Blue}
                        label={!counselling.isArchived ? FORUM_ADD_QUESTION : COUNSELLING_IS_ARCHIVED}
                        disabled={counselling.isArchived}
                        onClick={this.onAddPostClicked(() => {
                            onAddCounsellingQuestion(counselling);
                        }, `${counselling.id}`)}
                    />
                );
            }
        } else {
            if (!topic) {
                addBtn = (
                    <Btn
                        key="btn"
                        type={BtnType.Blue}
                        label={ADD_FEED_POST}
                        icon={fasPlusCircleLg}
                        link={isAuthenticated(requestUser) ? url(forumPostNewInTopicUrl, { categorySlug: OTHER_CATEGORY_SLUG, topicSlug: UNCATEGORIZED_TOPIC_SLUG }) : null}
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                );
            } else if (topic.id === CONTESTS_TOPIC_ID) {
                addBtn = isAdmin ? (
                    <Btn
                        key="btn"
                        type={BtnType.AdminOutline}
                        label={FORUM_ADD_CONTEST}
                        icon={fasPlusCircleLg}
                        link={url(forumContestNewUrl, {topicSlug: topic.slug})}
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                ) : null;
            } else if (topic.id === TESTINGS_TOPIC_ID) {
                addBtn = null;
            } else if (brandDaysCampaign) {
                addBtn = (isModerator || isAdmin) ? (
                    <Btn
                        key="btn"
                        type={isModerator ? BtnType.Blue : BtnType.AdminOutline}
                        label={ADD_FEED_POST}
                        icon={fasPlusCircleLg}
                        link={
                            isAuthenticated(requestUser) ? (
                            topic.category && topic.category.slug && topic.slug
                                ? url(forumPostNewInTopicUrl, { categorySlug: topic.category.slug, topicSlug: topic.slug })
                                : url(forumPostNewInCategoryUrl, { categorySlug: topic.category.slug })
                            ) : null
                        }
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                ) : null;
            } else {
                addBtn = (
                    <Btn
                        key="btn"
                        type={BtnType.Blue}
                        label={ADD_FEED_POST}
                        icon={fasPlusCircleLg}
                        link={
                            isAuthenticated(requestUser) ? (
                            topic.category && topic.category.slug && topic.slug
                                ? url(forumPostNewInTopicUrl, { categorySlug: topic.category.slug, topicSlug: topic.slug })
                                : url(forumPostNewInCategoryUrl, { categorySlug: topic.category.slug })
                            ) : null
                        }
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                );
            }
        }

        const hasComplaints = (isModerator || isAdmin) && Object.keys(complaintsStatistics).some((k) => complaintsStatistics[k].count > 0);
        const hasEdit = (isModerator || isAdmin) && !!topic;
        const hasDelete = isAdmin && topic && topic.id !== CONTESTS_TOPIC_ID && topic.id !== TESTINGS_TOPIC_ID;
        const hasAdminclub = topic && isAdmin;
        const hasSeoWithAI = topic && isAdmin;
        const hasSeoStats = topic && permissions.indexOf('users.can_access_dash') >= 0;
        let menu;
        if (hasComplaints || hasEdit || hasSeoWithAI || hasDelete || hasAdminclub || hasSeoStats) {
            const role = isAdmin ? 'admin' : (isModerator ? 'moderator' : '');
            menu = (
                <Menu
                    key="menu"
                    menuId={TOPIC_MENU_MORE}
                    trigger={
                        <Btn
                            type={BtnType.BlueOutline}
                            icon={fasCogLg}
                            onClick={onTopicToggleMenuMore}
                            bullet={hasComplaints}
                            bulletClassName={styles.TopicPage__menu__trigger__bullet}
                        />
                    }
                >
                    {hasComplaints && (
                        <MenuItem
                            label={FORUM_REPORTED_POSTS}
                            icon={faExclamationTriangle}
                            className={styles[`TopicPage__menu__item--${role}`]}
                            link={url(forumReportedUrl, {topicSlug: topic.slug})}
                            isAdminUI={!isModerator && isAdmin}
                        />
                    )}
                    {hasEdit && (
                        <MenuItem
                            label={FORUM_TOPIC_EDIT}
                            icon={faPencil}
                            link={url(forumTopicEditUrl, {topicId: topic.id})}
                            isAdminUI={!isModerator && isAdmin}
                        />
                    )}
                    {hasSeoWithAI && (
                        <MenuItem
                            label={FORUM_TOPIC_SEO_WITH_AI}
                            icon={faRobot}
                            link={url(adminclubSeoForumUrl, {}, {topicId: topic.id})}
                            isAdminUI={isAdmin}
                        />
                    )}
                    {hasDelete && (
                        <MenuItem
                            label={FORUM_TOPIC_DELETE}
                            icon={faTrash}
                            onClick={this.onDeleteCache(() => {
                            onTopicDelete(topic.slug);
                        }, topic.slug)}
                            isAdminUI
                        />
                    )}
                    {hasAdminclub && (
                        <MenuItem
                            label={FORUM_POST_ADMINCLUB_MENU}
                            icon={faLifeRing}
                            link={adminclub_forum_topic_url(topic.id)}
                            asAnchor
                            isAdminUI
                        />
                    )}
                    {hasSeoStats && (
                        <MenuItem
                            label="SEO traffic"
                            icon={faChartLine}
                            link={
                                url(dashSeoPerformaceUrl, {}, {
                                    range1: DateRange1[DateRange1.Past12Weeks],
                                    urls: (topic.category.id === COUNSELLING_CATEGORY_ID
                                        ? [ topicUrl(topic),
                                            '^' + url(counsellingsPostDetailUrl, {topicSlug: topic.slug, postSlug: 'xxx'}).replace(/xxx.*/, ''),
                                            // legacy urls, pred presunom na /ask-an-expert/*
                                            url(forumTopicUrl, {topicSlug: topic.slug}),
                                            '^' + url(forumPostDetailUrl, {topicSlug: topic.slug, postSlug: 'xxx'}).replace(/xxx.*/, ''),
                                        ] : [
                                            topicUrl(topic),
                                            '^' + url(forumPostDetailUrl, {topicSlug: topic.slug, postSlug: 'xxx'}).replace(/xxx.*/, ''),
                                        ]
                                    ).join('\n'),
                                    keywords: KeywordFilterType[KeywordFilterType.NonBranded],
                                })}
                            asAnchor
                            linkTarget="_blank"
                            isAdminUI
                        />
                    )}
                </Menu>
            );
        }
        return (!!menu || !!addBtn) && (
            <>
                {menu}
                {!!menu && !!addBtn && '\u00A0\u00A0'}
                {addBtn}
            </>
        );
    }

    public getSubmitButton(props: Props): React.ReactElement {
        return null;
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: 'forum',
            activeItem: 'topic',
        };
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumTopic', reducer);
        store.injectSaga('containers.forum.forumTopic', saga);
    }

}
